import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from '../icons/QuestionBlueIcon.jsx';

class InitiativeExampleCSVDownloadButton extends React.PureComponent {
  state = {
    showModal: false,
  };

  handleClose = () => this.setState({ showModal: false });

  handleShow = () => this.setState({ showModal: true });

  renderModal = () => (
    <Modal bsSize="sm" show={this.state.showModal} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>CSV Upload</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Need help getting started? Download our example CSV template. To
          successfully process your information, please follow the formatting of
          example template.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          block
          bsStyle="primary"
          href="/static/group-participations-example.csv"
          target="_blank"
        >
          Download Example CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  render() {
    return (
      <React.Fragment>
        <button
          aria-label="View help"
          type="button"
          className="btn-clear flex flex-align-center p-0 text-muted"
          onClick={this.handleShow}
        >
          Need Participants CSV Template? Click the question mark to download
          &nbsp;
          <QuestionBlueIcon />
        </button>
        {this.renderModal()}
      </React.Fragment>
    );
  }
}

export default InitiativeExampleCSVDownloadButton;
